import {createFormActionTypes} from "../../../../shared/ts/helpers/create_form_action_types";
import {createFormActions} from "../../../../shared/ts/helpers/create_form_actions";

export const OFFER_PLAN_LIST_FORM = "offer-plans/OFFER_PLAN_LIST_FORM";
export const offerPlanListFormTypes = createFormActionTypes(OFFER_PLAN_LIST_FORM);
export const offerPlanListFormActions = createFormActions(offerPlanListFormTypes);
